/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summary_Wpm_TitleInputs */



/**
* | output |
* | --- |
* | "Words per minute" |
*
* @param {Summary_Wpm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const summary_wpm_title = /** @type {((inputs?: Summary_Wpm_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summary_Wpm_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mots par minute")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wörter pro Minute")
	if (locale === "it") return /** @type {LocalizedString} */ ("Parole al minuto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Слова в минуту")
	if (locale === "es") return /** @type {LocalizedString} */ ("Palabras por minuto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每分钟字数")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1分あたりの単語数")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शब्द प्रति मिनट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Palavras por minuto")
	return /** @type {LocalizedString} */ ("Words per minute")
});